<template>
    <div class="fade-in">
        <div class="border rounded p-3 mb-3">
            <div class="row">
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Job Applied</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.candidateJob?.name || '--' }}</div>
                    </div>
                    <!-- <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Expected Salary</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.expectedSalary ?? '--' }}</div>
                    </div> -->
            </div>
        </div>
        <div class="border rounded p-3 mb-3">
            <div class="row">
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">First Name</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.firstName || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Last Name</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.lastName || '--' }}</div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <small class="text-muted d-block mb-1">English Name</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.englishName || '--' }}</div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <small class="text-muted d-block mb-1">Address</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ [candidate.address1, candidate.address2, candidate.address3].filter(item => item).join(', ') || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">City</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.city || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">State</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.state || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Postcode</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.postcode || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Country</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.country || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Phone</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.phoneNumber ? `${candidate.phoneCode || ''} ${candidate.phoneNumber}`.trim() : '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Home Phone</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.homePhoneNumber ? `${candidate.homePhoneCode || ''} ${candidate.homePhoneNumber}`.trim() : '--' }}</div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <small class="text-muted d-block mb-1">Email</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.email || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Birth Date</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.birthDate || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Birth Place</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.birthPlace || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Gender</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.gender == null ? '--' : (candidate.gender == 1 ? 'Male' : 'Female') }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Race</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.race || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Ethnicity</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.ethnicity || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Religion</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.religion || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Nationality</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.nationality || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Marital Status</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ maritalStatusDdl.find(item => item.value == candidate.maritalStatus)?.text || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Malaysia ID</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.malaysiaId || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Passport</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.passportNumber || '--' }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Passport Expired</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.passportExpiredDate || '--' }}</div>
                    </div>
            </div>
        </div>
        <div class="border rounded p-3">
            <div class="row">
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">If needed, are you willing to work overtime?</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.willingOt ? $t('label.yes') : $t('label.no') }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Can we contact you at work?</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.callDuringWork ? $t('label.yes') : $t('label.no') }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Are you willing to relocate?</small>
                        <div class="font-weight-bold text-break" style="white-space: pre-line;">{{ candidate.willingToRelocate ? $t('label.yes') : $t('label.no') }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <small class="text-muted d-block mb-1">Resume</small>
                        <a v-if="candidate.resumeUrl" :href="candidate.resumeUrl" target="_blank" rel="noopener noreferrer" class="text-info font-weight-bold">View Resume</a>
                        <span v-else class="font-weight-bold">--</span>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import { MARITAL_STATUS } from "@/constants/marital";

export default {
    props: {
        candidate: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            maritalStatusDdl: MARITAL_STATUS,
        };
    },
}
</script>
